/**
 * useBookings
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import BookingsContext from './bookings-context'

const useBookings = () => {
  const context = useContext(BookingsContext)
  return context
}

export default useBookings
